"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareRatioUtils = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
function countLeadingZeros(number) {
    const str = typeof number === "number" ? number.toString() : number;
    const decimalPart = str.split(".")[1];
    if (decimalPart === undefined)
        return 0; // 如果没有小数部分，返回0
    const match = decimalPart.match(/^0*/);
    return match ? match[0].length : 0;
}
var ShareRatioUtils;
(function (ShareRatioUtils) {
    function shareRatioFormat(value, $num) {
        const l = countLeadingZeros(value || "");
        if (l < 8)
            return $num(value || "", { precision: 8 });
        return trade_utils_lib_1.NumberCommonUtils.toNormalPrice(value || "");
    }
    ShareRatioUtils.shareRatioFormat = shareRatioFormat;
})(ShareRatioUtils || (exports.ShareRatioUtils = ShareRatioUtils = {}));
